module.exports = __webpack_public_path__ + "needle-ip6.png?ab0cd9464b949cfc182616a85caa415a";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/needle-ip6.png
// module id = 66
// module chunks = 0